import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Fade } from '@material-ui/core';
import { getTestIds } from '../../utils/TestIds';
import { useSpotlightTargetMeasurement } from '../../utils/useSpotlightTargetMeasurement';
const generateMaskId = ()=>"spotlight-mask-".concat(Date.now().toString(36), "-").concat(Math.random().toString(36).slice(2, 10));
export const GetSpotlightTID = (parentTestId)=>getTestIds(parentTestId);
const DEFAULT_PADDING = 0;
const DEFAULT_BORDER_RADIUS = 0;
const DEFAULT_BACKDROP_COLOR = 'rgba(0, 0, 0, 0.32)';
export function Spotlight(props) {
    var _ref;
    const { spotlightId, padding = DEFAULT_PADDING, borderRadius, backdropColor = DEFAULT_BACKDROP_COLOR, zIndex, testId, open = true, onClick } = props;
    const measurement = useSpotlightTargetMeasurement(spotlightId);
    const [maskId] = useState(generateMaskId);
    const { SpotlightTID } = useMemo(()=>GetSpotlightTID(testId), [
        testId
    ]);
    const containerStyle = {
        position: 'fixed',
        inset: 0,
        zIndex,
        pointerEvents: 'none'
    };
    if (measurement == null) {
        return /*#__PURE__*/ _jsx(Fade, {
            in: open,
            children: /*#__PURE__*/ _jsx("div", {
                "data-testid": SpotlightTID.Root(),
                style: _object_spread_props(_object_spread({}, containerStyle), {
                    backgroundColor: backdropColor,
                    pointerEvents: 'auto'
                }),
                onClick: onClick,
                "aria-hidden": true
            })
        });
    }
    const { rect, borderRadius: measuredRadius } = measurement;
    const resolvedRadius = (_ref = borderRadius !== null && borderRadius !== void 0 ? borderRadius : measuredRadius) !== null && _ref !== void 0 ? _ref : DEFAULT_BORDER_RADIUS;
    const holeX = rect.left - padding;
    const holeY = rect.top - padding;
    const holeWidth = rect.width + 2 * padding;
    const holeHeight = rect.height + 2 * padding;
    return /*#__PURE__*/ _jsx(Fade, {
        in: open,
        children: /*#__PURE__*/ _jsx("div", {
            "data-testid": SpotlightTID.Root(),
            style: containerStyle,
            "aria-hidden": true,
            children: /*#__PURE__*/ _jsxs("svg", {
                width: "100%",
                height: "100%",
                style: {
                    pointerEvents: 'auto'
                },
                children: [
                    /*#__PURE__*/ _jsx("defs", {
                        children: /*#__PURE__*/ _jsxs("mask", {
                            id: maskId,
                            children: [
                                /*#__PURE__*/ _jsx("rect", {
                                    width: "100%",
                                    height: "100%",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ _jsx("rect", {
                                    "data-testid": SpotlightTID.Cutout(),
                                    x: holeX,
                                    y: holeY,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: resolvedRadius,
                                    ry: resolvedRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        "data-testid": SpotlightTID.Backdrop(),
                        width: "100%",
                        height: "100%",
                        fill: backdropColor,
                        mask: "url(#".concat(maskId, ")"),
                        onClick: onClick
                    })
                ]
            })
        })
    });
}
